<script>
import {defineComponent} from 'vue'
import Bouton from "../../components/ob1/Bouton.vue";
import FeedbackModalDialog from "../../components/vue/FeedbackModalDialog.vue";

export default defineComponent({
    name: "WaitingXhrPage",
    components: {FeedbackModalDialog, Bouton},
    props: {
        dto: {
            type: Object,
            required: true
        },
        token: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            needConfirmation: false,
            confirmationParameters: null,
            confirmationMessage: null
        }
    },
    mounted() {
        this.initCart();
    },
    methods: {
        initCart() {
            const param = this.dto.parameters;
            param['token'] = this.token;

            this.sendRequest(param);
        },
        initConfirmationCart() {
            const param = this.confirmationParameters;
            param['token'] = this.token;

            this.$refs.feedbackConfirmationDialog?.close();
            this.sendRequest(param);
        },
        sendRequest(parameters) {
            const genericApiUrl = this.dto.initCartUrl;
            const genericErrorUrl = this.dto.genericErrorUrl;

            $.ajax({
                method: "POST",
                url: genericApiUrl,
                contentType: "application/json",
                data: JSON.stringify(parameters)
            }).done((response) => {
                const url = response.redirectUrl;
                window.location.replace(url);
            }).fail((xhr) => {
                if (xhr.status === 403) {
                    // Pour les erreurs d'authentifications, on reload simplement la page
                    // appelant la xhr. MyShop va reprendre la main et gérer la perte de session.
                    location.reload();
                } else if (xhr.status === 412 && xhr.responseJSON) {
                    this.confirmationParameters = xhr.responseJSON.parameters;
                    this.confirmationMessage = xhr.responseJSON.message;
                    this.$nextTick(() => {
                        this.$refs.feedbackConfirmationDialog?.open();
                    });
                } else if (xhr.redirectUrl) {
                    window.location.replace(xhr.redirectUrl);
                } else {
                    window.location.replace(genericErrorUrl);
                }
            });
        }
    }
})
</script>

<template>
    <div class="d-flex justify-content-center u-fill-height visible">
        <ob1-progress-indicators :size="50" type="undetermined" class="my-auto" />
        <FeedbackModalDialog
            v-if="confirmationMessage"
            ref="feedbackConfirmationDialog"
            :id="'confirmationDialog'"
            :modal-content="confirmationMessage.text"
            :modal-title="confirmationMessage.title"
        >
            <template #actionButton>
                <bouton
                    :label="confirmationMessage.buttonLabel"
                    :is-primary="false"
                    @click="initConfirmationCart"
                />
            </template>
        </FeedbackModalDialog>
    </div>
</template>

<style scoped lang="scss">

</style>
